import { LineRunningStatusWidgetContainer } from './LineRunningStatusWidget.elements';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';
import CheckCircle from 'icons/indexed-icons/CheckCircle';
import them from 'common/theme';
import { Machine } from 'pages';
import MachineUsageCard from './MachineUsageCard/MachineUsageCard';
import RunningGaugeChart from './RunningGuageChart/RunningGuageChart';

interface Machine {
    name: string;
    id: string;
}

interface LineRunningStatusWidgetProps {
    lineActualRunningValue?: number;
    lineRunningTarget?: number;
    selectedNoOfDays?: number;
    machines: Machine[];
}

const hoursPerDay = 24;

const LineRunningStatusWidget = ({
    lineActualRunningValue = 0,
    lineRunningTarget = 0,
    machines,
    selectedNoOfDays
}: LineRunningStatusWidgetProps) => {
    const isOnTrack = lineActualRunningValue >= lineRunningTarget;
    const maxHours = (selectedNoOfDays ?? 0) * hoursPerDay;

    return (
        <LineRunningStatusWidgetContainer className="line-running-status-widget" borderColor={isOnTrack ? them.colors.success200 : them.colors.error200}>
            <div className="line-running-status-widget__title">
                {isOnTrack ? (
                    <CheckCircle color={them.colors.success200} />
                ) : (
                    <TriangleWarning color={them.colors.error200} />
                )}
                <div className="line-running-status-widget__title-text">Running</div>
            </div>
            <div className='line-running-status-widget__gauge-chart'>
                <RunningGaugeChart
                    value={lineActualRunningValue}
                    target={lineRunningTarget}
                    max={maxHours}
                    isOnTrack={isOnTrack}
                />
            </div>
            <div className='line-running-status-widget__description'>
                <MachineUsageCard
                    lineRunningTarget={lineRunningTarget}
                    machines={machines}
                    maxHours={maxHours}
                />
            </div>
        </LineRunningStatusWidgetContainer>
    );
}

export default LineRunningStatusWidget;
